<template>
  <van-popup
    :show="show"
    position="center"
    round
    teleport="body"
    :close-on-click-overlay="false"
    class="cps-coupon-popup"
    @update:show="handleVisibilityChange"
  >
    <section
      class="cps-coupon-content"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cps-coupon-title"
    >
      <h2 id="cps-coupon-title">Exclusive Voucher</h2>
      <p>I got this voucher for you!</p>

      <div class="cps-coupon-amount">
        {{ currencySymbol }} {{ amount }} OFF
      </div>

      <div class="cps-coupon-actions">
        <button type="button" class="claim-button" @click="$emit('claim')">
          Claim
        </button>
        <button type="button" class="close-button" @click="$emit('close')">
          Close
        </button>
      </div>
    </section>
  </van-popup>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
  amount: number | string
  currencySymbol: string
}>()

const emit = defineEmits<{
  (event: 'update:show', value: boolean): void
  (event: 'claim'): void
  (event: 'close'): void
}>()

const handleVisibilityChange = (show: boolean) => {
  emit('update:show', show)
}
</script>

<style scoped lang="scss">
.cps-coupon-popup {
  width: 600px;
  max-width: calc(100vw - 24px);
  overflow: hidden;
  border-radius: 30px;
}

.cps-coupon-content {
  box-sizing: border-box;
  width: 100%;
  padding: 56px 48px 40px;
  text-align: center;

  h2 {
    margin: 0;
    color: #202124;
    font-size: 34px;
    font-weight: 700;
    line-height: 1.25;
  }

  p {
    margin: 8px 0 26px;
    color: #969696;
    font-size: 24px;
    line-height: 1.35;
  }
}

.cps-coupon-amount {
  display: flex;
  min-height: 82px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 336px;
  max-width: 100%;
  margin: 0 auto;
  padding: 12px 20px;
  color: #ed343b;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
  background: #fff7f7;
  border: 2px dashed #ed343b;
  border-radius: 16px;
}

.cps-coupon-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
  margin-top: 34px;

  button {
    width: 100%;
    min-width: 0;
    height: 82px;
    padding: 0 12px;
    font-size: 30px;
    line-height: 1;
    border: 0;
    border-radius: 20px;
    cursor: pointer;
  }
}

.claim-button {
  color: #fff;
  font-weight: 700;
  background: #ed343b;
}

.close-button {
  color: #626262;
  font-weight: 500;
  background: #f5f5f5;
}

@media (max-width: 360px) {
  .cps-coupon-content {
    padding-right: 28px;
    padding-left: 28px;
  }
}
</style>
